import { render, staticRenderFns } from "./SettlementDetailReport.vue?vue&type=template&id=5a2fed60&"
import script from "./SettlementDetailReport.vue?vue&type=script&lang=ts&"
export * from "./SettlementDetailReport.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5a2fed60')) {
      api.createRecord('5a2fed60', component.options)
    } else {
      api.reload('5a2fed60', component.options)
    }
    module.hot.accept("./SettlementDetailReport.vue?vue&type=template&id=5a2fed60&", function () {
      api.rerender('5a2fed60', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/trucking/reports/SettlementDetailReport.vue"
export default component.exports